import React from "react";
import { useTranslation } from "react-i18next";
import DOCOnlineWorkExperienceForm from "./DOCOnlineWorkExperienceForm";

const DOCOnlineWorkExperience = ({


  docOnline,
  setDocOnline,
  errors
}) => {
  const { t } = useTranslation();

  

  function canAddNewWorkExperience() {
    let isValid = true;
    let lastItemIndex = docOnline.workExperience.length - 1;

    if (Object.keys(docOnline.workExperience[lastItemIndex]).length === 0) {
      isValid = false;
    }
    return isValid;
  }

  function DeleteWorkExperience(index) {
    let _workExperience = [...docOnline.workExperience];
    _workExperience.splice(index, 1);
    setDocOnline({ ...docOnline, workExperience: _workExperience });
  }

  function AddWorkExperience() {
    if (canAddNewWorkExperience()) {
      let _workExperience = [...docOnline.workExperience];
      _workExperience.push({});
      setDocOnline({ ...docOnline, workExperience: _workExperience });
    }
  }

  return (
    <section className="step">
      <h2 className="title-style">{t("Work Experience")}</h2>
      <div className="doc-subtitle subtitle-style">
        {t(
          "Describe all your professional work experience. Please, start with the most recent work experience up to the oldest one, in descending chronological order. In case you worked in multiple projects, please include them in your work experience."
        )}
      </div>
      <div className="card inboard p-4">
        <div className="doc-main">
          {docOnline.workExperience.map((item, index) => {
            return (
              <DOCOnlineWorkExperienceForm
                key={index}
                index={index}
                onDelete={DeleteWorkExperience}
                workExperience={item}
                docOnline={docOnline}
                setDocOnline={setDocOnline}
                errors={errors}
              />
            );
          })}
          {Object.keys(
            docOnline.workExperience[
              docOnline.workExperience.length - 1
            ]
          ).length === 0 ? (
            <button disabled className="app-button btn-prime btn-md position-button">
              {t("Add another work experience")}
            </button>
          ) : (
            <div className="app-button btn-prime btn-md position-button" onClick={AddWorkExperience}>
              {t("Add another work experience")}
            </div>
          )}
        </div>
      </div>
     
    </section>
  );
};

export default DOCOnlineWorkExperience;
